import settings from '@shared/settings'
import i18n from '@shared/module/i18n'
import store from '@shared/store'
import format from 'date-fns/format'

export function showChatBubble() {
  const existCondition = setInterval(() => {
    if (document.getElementsByClassName('cvc-s').length) {
      clearInterval(existCondition)
      document.getElementsByClassName('cvc-s')[0].classList.add('show')
      setChatLanguage()
      setCustomerInformation()
    }
  }, 100)
  setTimeout(() => {
    clearInterval(existCondition)
  }, 10000)
}

export function openChat() {
  const existCondition = setInterval(() => {
    if (document.getElementById('cvc-container')) {
      clearInterval(existCondition)
      document.getElementById('cvc-container').childNodes[0].click()
      setChatLanguage()
      setCustomerInformation()
    }
  }, 100)
  setTimeout(() => {
    clearInterval(existCondition)
  }, 10000)
}

export function setChatLanguage(language) {
  if (window.cvc) {
    window.cvc.setLanguage(language || i18n.locale)
  }
}

export function setCustomerInformation() {
  const currentUser = store.state.currentUser
  if (window.cvc) {
    if (currentUser) {
      window.cvc.setUser(currentUser.fullName)
      window.cvc.setCad({ customerPhone: currentUser.gsm })
    } else {
      const chatUserName = getUniqueChatUsername()
      window.cvc.setUser(chatUserName)
    }
  }
}

export default () => {
  const container = document.getElementById('cvc-c')
  if (container) return

  const scr = document.createElement('script')
  scr.src = 'https://iutevisitor.prominion.net/ecf/latest/VisitorChat/resources/lib/cvc.min.js'
  scr.id = 'cvc-c'
  scr.setAttribute('data-cc', settings.sapChatCC())
  scr.setAttribute('data-ic', settings.sapChatIC())
  document.head.appendChild(scr)

  hideChatBubble()
}

function hideChatBubble() {
  if (window.cvc) {
    document.getElementById('cvc-container').firstChild.style.display = 'none'
    document.getElementById('cvc-container').addEventListener('transitionend', () => {
      document.getElementById('cvc-container').firstChild.style.display = 'none'
    })
  } else {
    setTimeout(hideChatBubble, 10)
  }
}

function getUniqueChatUsername() {
  let chatUserName = store.getChatUsername()
  if (!chatUserName) {
    chatUserName = format(new Date(), "'Customer 'dd.MM-HH:mm:ss")
    store.setChatUsername(chatUserName)
  }
  return chatUserName
}
